import { isNumber, isNumeric } from "./is.mjs";
export const toNumber = (value) => {
  return isNumber(value) ? value : Number(value);
};
export const toNumberic = (value) => {
  return isNumeric(value) ? Number(value) : value;
};
